import {
  div,
  h1,
  input,
  button,
  img,
  fnstate,
  span,
  form,
  goTo
} from '@srfnstack/fntags'
import { user } from '../state.js'

export const Login = () => {
  const error = fnstate('')
  const loading = fnstate(false)

  const handleLogin = async (e) => {
    e.preventDefault()
    error('')
    loading(true)

    const formData = new FormData(e.target)

    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: formData.get('username'),
          password: formData.get('password')
        })
      })

      const result = await res.json()
      if (res.ok) {
        user({ loggedIn: true, ...result.user })
        goTo('/')
      } else {
        error(result.error || 'Login failed')
      }
    } catch (err) {
      error('Network error')
    } finally {
      loading(false)
    }
  }

  // const handleOAuth = (provider) => {
  //   // In a real app, this would redirect to provider or open a popup
  //   window.alert(`${provider} OAuth not fully implemented in UI yet.`)
  // }

  return div({ class: 'min-h-screen flex items-center justify-center bg-base-300' },
    div({ class: 'card bg-base-100 shadow-2xl w-96 overflow-hidden border border-base-300' },
      div({ style: 'background-color: #282f3f', class: 'p-8 flex justify-center' },
        img({ src: '/images/etherbuildr_logo.png', alt: 'EtherBuildr', style: 'height: 60px;' })
      ),
      div({ class: 'p-8 space-y-4' },
        h1({ class: 'text-xl font-bold text-center mb-4' }, 'AUTHENTICATION'),
        error.bindAs(err => err ? div({ class: 'alert alert-error text-xs p-2' }, span(err)) : ''),
        form({ onsubmit: handleLogin, class: 'space-y-4' },
          div({ class: 'form-control' },
            input({
              id: 'username',
              type: 'text',
              name: 'username',
              autocomplete: 'username',
              placeholder: 'Username or Email',
              class: 'input input-bordered w-full'
            })
          ),
          div({ class: 'form-control' },
            input({
              id: 'password',
              type: 'password',
              name: 'password',
              autocomplete: 'password',
              placeholder: 'Password',
              class: 'input input-bordered w-full'
            })
          ),
          button({
            class: 'btn btn-primary w-full',
            type: 'submit',
            disabled: loading.bindAttr()
          }, loading.bindAs(l => l ? span({ class: 'loading loading-spinner' }) : 'Authenticate'))
        )
        // div({ class: 'divider' }, 'OR'),
        //
        // div({ class: 'flex gap-2' },
        //   button({
        //     class: 'btn btn-outline flex-1 gap-2',
        //     onclick: () => handleOAuth('Google')
        //   }, 'Google'),
        //   button({
        //     class: 'btn btn-outline flex-1 gap-2',
        //     onclick: () => handleOAuth('Facebook')
        //   }, 'Facebook')
        // ),
        //
        // p({ class: 'text-center text-xs mt-4' },
        //   'Don\'t have an account? ',
        //   button({
        //     class: 'link link-primary',
        //     onclick: () => user.assign({ showSignup: true })
        //   }, 'Sign Up')
        // )
      )
    )
  )
}
